import get from 'lodash.get';

const getAllTemplatesCount = (rootState) => get(rootState, 'templates.data.count');

export default getAllTemplatesCount;
